import {
  Directive,
  ElementRef,
  Inject,
  InjectionToken,
  Optional
} from '@angular/core';

export const HEIGHT_PROVIDER = new InjectionToken<HeaderHeightProvider>(
  'HEIGHT_PROVIDER'
);

export interface HeaderHeightProvider {
  headerHeight: number;
}

@Directive({
  selector: '[mrt-insights-header]'
})
export class DetailsPageHeaderDirective {
  public get headerHeight(): number {
    if (this.heightProvider) {
      return this.heightProvider.headerHeight;
    } else {
      return this.element.nativeElement.getBoundingClientRect().height;
    }
  }

  constructor(
    private element: ElementRef<HTMLElement>,
    @Optional()
    @Inject(HEIGHT_PROVIDER)
    private heightProvider: HeaderHeightProvider | null
  ) {}
}
